import { RoleModel } from '@/types';

export interface PermissionModel {
    id: string;
    module: string;
    description?: string;
    roles: RoleModel[];
}
